/**
 * Created by linxiao on 2019/11/19.
 */
// import katex from 'katex';
// import renderMathInElement from 'katex/dist/contrib/auto-render.min.js';

let ubbToHtml = {}
const defaultOptions = {
  delimiters:[
    {left: "$$", right: "$$", display: false},
    {left: "$", right: "$", display: false},
    {left: "\\(", right: "\\)", display: false},
    {left: "\\[", right: "\\]", display: false},
    {left: "\\{", right: "\\}", display: false}
  ]
}

const katexDirective = {
  name: 'katex',
  directive: function(el, binding) {
    const expression = binding.value;
    const additionalOptions = binding.options || defaultOptions;

    const options = Object.assign({
        displayMode: binding.arg === 'display',
      },
      additionalOptions);
    try {
      expression && katex.render(expression, el, options);
    } catch (e) {
      if (e instanceof katex.ParseError) {
        el.innerHTML = expression;
        renderMathInElement(el, options);
      } else {
        throw e;  // other error
      }
    }
  },
};
const katexStringDirective = {
  name: 'katexString',
  directive: function(el, binding) {
    const expression = binding.value;
    const additionalOptions = binding.options || defaultOptions;

    const options = Object.assign({
        displayMode: binding.arg === 'display',
      },
      additionalOptions);

    const elHtml = katex.renderToString(expression, options);
    el.innerHTML = elHtml;
  },
};
const katexHtmlDirective = {
  name: 'katexHtml',
  directive: function(el, binding) {
      const expression = binding.value;
      const additionalOptions = binding.options || defaultOptions;

      const options = Object.assign({
              displayMode: binding.arg === 'display',
          },
          additionalOptions);
      let katexHtml = expression ? expression.replace(/begin\{array\}\{(\*\{\d+}\{\w\}|\w)\}/ig, 'begin\{array\}')
        .replace(/begin\{array\}/ig,'begin\{matrix\}')
        .replace(/end\{array\}/ig,'end\{matrix\}')
        .replace(/overrightarrow&nbsp;/ig, "overrightarrow")
        .replace(/overleftarrow&nbsp;/ig, "overleftarrow")
        .replace(/\\angle/ig, "\\angle ")
        .replace(/vec&nbsp;/ig, "vec ")
        .replace(/begin\{align\}/ig,'begin\{aligned\}')
        .replace(/because\\]/ig,'because\\]&nbsp;')
        .replace(/\\buildrel(((?!\\buildrel).)*)\\over/g, '\\stackrel$1')
        .replace(/sqrt&nbsp;/ig, 'sqrt')
        .replace(/sqrt&nbsp;&nbsp;/ig, 'sqrt')
        .replace(/end\{align\}/ig,'end\{aligned\}') : expression;
      katexHtml = katexHtml.replace(/\$\$/ig,'')
        // .replace(/\\\)\\\(/ig,'') // 影响到了该题型 已知\\(\\odot\\)\\(Q:{(x&nbsp;-&nbsp;1)^2}&nbsp;+&nbsp;{y^2}&nbsp;=&nbsp;16\\)，动\\(\\odot\\)\\(M\\)过定点\\(P(&nbsp;-&nbsp;1,0)\\)且与\\(\\odot\\)\\(Q\\)相切，则\\(M\\)点的轨迹方程是(&nbsp;&nbsp;&nbsp;)
        .replace(/\\\]\\\[/ig,'');
      el.innerHTML = katexHtml
        renderMathInElement(el, options);

  },
};


const isUndefined = (variable) => {
  return typeof variable == 'undefined';
}
const preg_replace = (search, replace, str) => {
  var len = search.length, re
  for (var i = 0; i < len; i++) {
    re = new RegExp(search[i], 'ig')
    str = str.replace(re, typeof replace === 'string' ? replace : (replace[i] ? replace[i] : replace[0]))
  }
  return str
}
const parsetable = (width, bgcolor, str) => {
  if (isUndefined(width)) {
    let width = ''
  } else {
    width = width.substr(width.length - 1, width.length) == '%' ? (width.substr(0, width.length - 1) <= 98 ? width : '98%') : (width <= 560 ? width : '98%')
  }

  str = str.replace(/\[tr(?:=([\(\)%,#\w]+))?\]\s*\[td(?:=(\d{1,2}),(\d{1,2})(?:,(\d{1,4}%?))?)?\]/ig, function($1, $2, $3, $4, $5) {
    return '<tr' + ($2 ? ' style="background: ' + $2 + '"' : '') + '><td' + ($3 ? ' colspan="' + $3 + '"' : '') + ($4 ? ' rowspan="' + $4 + '"' : '') + ($5 ? ' width="' + $5 + '"' : '') + '>'
  })
  str = str.replace(/\[\/td\]\s*\[td(?:=(\d{1,2}),(\d{1,2})(?:,(\d{1,4}%?))?)?\]/ig, function($1, $2, $3, $4) {
    return '</td><td' + ($2 ? ' colspan="' + $2 + '"' : '') + ($3 ? ' rowspan="' + $3 + '"' : '') + ($4 ? ' width="' + $4 + '"' : '') + '>'
  })
  str = str.replace(/\[\/td\]\s*\[\/tr\]/ig, '</td></tr>')

  return '<table ' + (width == '' ? '' : 'width="' + width + '" ') + 'class="t_table"' + (isUndefined(bgcolor) ? '' : ' style="background: ' + bgcolor + '"') + '>' + str + '</table>'
}
const addslashes = (str) => {
  return preg_replace(['\\\\', '\\\'', '\\\/', '\\\(', '\\\)', '\\\[', '\\\]', '\\\{', '\\\}', '\\\^', '\\\$', '\\\?', '\\\.', '\\\*', '\\\+', '\\\|'], ['\\\\', '\\\'', '\\/', '\\(', '\\)', '\\[', '\\]', '\\{', '\\}', '\\^', '\\$', '\\?', '\\.', '\\*', '\\+', '\\|'], str)
}
const bbcode2html = (str) => {
  if (!str) return ''
  str = str && str.trim()

  if (str == '') {
    return ''
  }
  const allowsmilies = !0
  if (allowsmilies) {
    let smilies = new Array()
    for (var i = 1; i <= 70; i++) {
      if (i <= 9) { smilies[i] = { 'code': '[em0' + i + ']', 'url': 'default/0' + i + '.gif' } } else { smilies[i] = { 'code': '[em' + i + ']', 'url': 'default/' + i + '.gif' } }
    }
    for (var id = 1; id < smilies.length; id++) {
      re = new RegExp(addslashes(smilies[id]['code']), 'g')
      str = str.replace(re, '<img src="./images/smilies/' + smilies[id]['url'] + '" border="0" smilieid="' + id + '" alt="' + smilies[id]['code'] + '" />')
    }
  }
  const allowbbcode = !0
  if (allowbbcode) {
    str = str.replace(/\[hr\]/ig, '<hr />')
    str = str.replace(/\[url\]\s*(www.|https?:\/\/|ftp:\/\/|gopher:\/\/|news:\/\/|telnet:\/\/|rtsp:\/\/|mms:\/\/|callto:\/\/|bctp:\/\/|ed2k:\/\/){1}([^\[\"']+?)\s*\[\/url\]/ig, function($1, $2, $3) { return cuturl($2 + $3) })
    str = str.replace(/\[url=www.([^\[\"']+?)\](.+?)\[\/url\]/ig, '<a href="http://www.$1" target="_blank">$2</a>')
    str = str.replace(/\[url=(https?|ftp|gopher|news|telnet|rtsp|mms|callto|bctp|ed2k){1}:\/\/([^\[\"']+?)\]([\s\S]+?)\[\/url\]/ig, '<a href="$1://$2" target="_blank">$3</a>')
    // str= str.replace(/\[email\](.*?)\[\/email\]/ig, '<a href="mailto:$1">$1</a>');
    // str= str.replace(/\[email=(.[^\[]*)\](.*?)\[\/email\]/ig, '<a href="mailto:$1" target="_blank">$2</a>');
    str = str.replace(/\[color=([^\[\<]+?)\]/ig, '<font color="$1">')
    str = str.replace(/\[backcolor=([^\[\<]+?)\]/ig, '<font style="background-color:$1">')
    str = str.replace(/\[size=(\d+?)\]/ig, '<font size="$1">')
    str = str.replace(/\[size=(\d+(\.\d+)?(px|pt|in|cm|mm|pc|em|ex|%)+?)\]/ig, '<font style="font-size: $1">')
    str = str.replace(/\[font=([^\[\<]+?)\]/ig, '<font face="$1">')
    str = str.replace(/\[align=([^\[\<]+?)\]/ig, '<p align="$1">')
    str = str.replace(/\[p=(\d{1,2}|null), (\d{1,2}), (left|center|right)\]/ig, '<p style="line-height: $1px; text-indent: $2em; text-align: $3;">')
    str = str.replace(/\[float=([^\[\<]+?)\]/ig, '<br style="clear: both"><span style="float: $1;">')

    var re = /\[table(?:=(\d{1,4}%?)(?:,([\(\)%,#\w ]+))?)?\]\s*([\s\S]+?)\s*\[\/table\]/ig
    for (i = 0; i < 4; i++) {
      str = str.replace(re, function($1, $2, $3, $4) { return parsetable($2, $3, $4) })
    }

    str = preg_replace(['\\\[div\\\]', '\\\[\\\/div\\\]',
      '\\\[\\\/backcolor\\\]', '\\\[\\\/color\\\]', '\\\[\\\/size\\\]', '\\\[\\\/font\\\]', '\\\[\\\/align\\\]', '\\\[\\\/p\\\]', '\\\[b\\\]', '\\\[\\\/b\\\]',
      '\\\[i\\\]', '\\\[\\\/i\\\]', '\\\[strike\\\]', '\\\[\\\/strike\\\]', '\\\[sup\\\]', '\\\[\\\/sup\\\]', '\\\[sub\\\]', '\\\[\\\/sub\\\]', '\\\[u\\\]', '\\\[\\\/u\\\]', '\\\[list\\\]', '\\\[list=1\\\]', '\\\[list=a\\\]',
      '\\\[list=A\\\]', '\\\[\\\*\\\]', '\\\[\\\/list\\\]', '\\\[indent\\\]', '\\\[\\\/indent\\\]', '\\\[\\\/float\\\]'
    ], ['<div>', '</div>',
      '</font>', '</font>', '</font>', '</font>', '</p>', '</p>', '<b>', '</b>', '<i>',
      '</i>', '<strike>', '</strike>', '<sup>', '</sup>', '<sub>', '</sub>', '<u>', '</u>', '<ul>', '<ul type=1>', '<ul type=a>',
      '<ul type=A>', '<li>', '</ul>', '<blockquote>', '</blockquote>', '</span>'
    ], str)
  }
  let allowimgcode = !0
  if (allowimgcode) {
    str = str.replace(/\[localimg=(\d{1,4}),(\d{1,4})\](\d+)\[\/localimg\]/ig, function($1, $2, $3, $4) { if ($('attach_' + $4)) { var src = $('attach_' + $4).value; if (src != '') return '<img style="filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=\'scale\',src=\'' + src + '\');width:' + $2 + ';height=' + $3 + '" src=\'images/common/none.gif\' border="0" aid="attach_' + $4 + '" alt="" />' } })
    str = str.replace(/\[img\](.*?)\[(\\?)\/img\]/ig, '<img src="$1" border="0" alt="" />')
    // str = str.replace(/\[img\]\s*([^\[\<\r\n]+?)\s*\[\/img\]/ig, '<img src="$1" border="0" alt="" />');
    str = str.replace(/\[attachimg\](\d+)\[\/attachimg\]/ig, function($1, $2) { eval('var attachimg = $(\'preview_' + $2 + '\')'); width = is_ie ? parseInt(attachimg.currentStyle.width) : attachimg.width; return '<img src="' + attachimg.src + '" border="0" aid="attachimg_' + $2 + '" width="' + width + '" alt="" />' })
    str = str.replace(/\[img=(\d{1,4})[x|\,](\d{1,4})\](.*?)\[(\\?)\/img\]/ig, '<img width="$1" height="$2" src="$3" border="0" alt="" />')
  } else {
    str = str.replace(/\[img\]\s*([^\[\<\r\n]+?)\s*\[(\\?)\/img\]/ig, '<a href="$1" target="_blank">$1</a>')
    str = str.replace(/\[img=(\d{1,4})[x|\,](\d{1,4})\]\s*([^\[\<\r\n]+?)\s*\[(\\?)\/img\]/ig, '<a href="$1" target="_blank">$1</a>')
  }
  const forumallowhtml = !0
  const allowhtml = !0
  if (!forumallowhtml && !allowhtml) {
    str = preg_replace(['\t', '   ', '  ', '(\r\n|\n|\r)'], ['&nbsp; &nbsp; &nbsp; &nbsp; ', '&nbsp; &nbsp;', '&nbsp;&nbsp;', '<br />'], str)
  }
  // str = str.replace(/\\/g, '\/')
  return str
}


const katexUbbDirective = {
  name: 'katexUbb',
  directive: function(el, binding) {
    const expression = binding.value;
    const additionalOptions = binding.options || defaultOptions;

    const options = Object.assign({
        displayMode: binding.arg === 'display',
      },
      additionalOptions);
    try {
      let ubbTohtml = bbcode2html(expression ? expression.replace(/begin\{array\}\{(\*\{\d+}\{\w\}|\w)\}/ig, 'begin\{array\}')
      .replace(/begin\{array\}/ig,'begin\{matrix\}')
      .replace(/end\{array\}/ig, 'end\{matrix\}')
      .replace(/begin\{align\}/ig,'begin\{aligned\}')
      .replace(/overrightarrow&nbsp;/ig, "overrightarrow")
      .replace(/overleftarrow&nbsp;/ig, "overleftarrow")
      .replace(/\\angle/ig, "\\angle ")
      .replace(/\\buildrel(((?!\\buildrel).)*)\\over/g, '\\stackrel$1')
      .replace(/sqrt&nbsp;/ig, 'sqrt')
      .replace(/sqrt&nbsp;&nbsp;/ig, 'sqrt')
      .replace(/end\{align\}/ig, 'end\{aligned\}') : expression);
      ubbTohtml = ubbTohtml.replace(/\$\$/ig,'')
        .replace(/\\\)\\\(/ig,'')
        .replace(/\\\]\\\[/ig,'');
      el.innerHTML = ubbTohtml;
      renderMathInElement(el, options);
    } catch (e) {
      if (e instanceof katex.ParseError) {
        expression && katex.render(expression, el, options);
      } else {
        throw e;  // other error
      }
    }
  },
};

const ubbBindFn = (el, value) => {
  if (el.tagName.toLocaleLowerCase() === 'input') {
    el.value = value
  } else {
    el.innerHTML = value
  }
  // formatMathJax(el)
  MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
}

ubbToHtml.install = function(Vue, option) {
  Vue.directive('ubbToHtml', {
    bind (el, binding) {
      // const value = binding.value.replace(/\\\\/g, '\\')
      if (binding.value) {
        if (typeof (binding.value) == 'object') {
          binding.value = binding.value.toString();
        } else if (typeof (binding.value) == 'number') {
          binding.value = binding.value +'';
        }
        const value2 = binding.value.replace(/\\\[/g, '\\\(')
        const value3 = value2.replace(/\\\]/g, '\\\)')
        ubbBindFn(el, value3)
      }
    },
    update (el, binding) {
      if (binding.value === binding.oldValue) { return }
      // const value = binding.value.replace(/\\\\/g, '\\')
      if (binding.value) {
        if (typeof (binding.value) == 'object') {
          binding.value = binding.value.toString();
        } else if (typeof (binding.value) == 'number') {
          binding.value = binding.value +'';
        }
        const value2 = binding.value.replace(/\\\[/g, '\\\(')
        const value3 = value2.replace(/\\\]/g, '\\\)')
        ubbBindFn(el, value3)
      }
    }
  })
}


export default {
  install(Vue) {
    Vue.directive(katexDirective.name, katexDirective.directive);
    Vue.directive(katexStringDirective.name, katexStringDirective.directive);
    Vue.directive(katexHtmlDirective.name, katexHtmlDirective.directive);
    Vue.directive(katexUbbDirective.name, katexUbbDirective.directive);
  },
  ubbToHtml
};




// WEBPACK FOOTER //
// ./src/utils/katex-directive.js